import api from "@/api";
const Connector = {
  install(Vue) {
    Vue.mixin({
      methods: {
        activateRequest(token) {
          return new Promise((resolve, reject) => {
            api.auth
              .activate(token)
              .then(() => {
                resolve();
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        registerRequest: (data) => {
          return new Promise((resolve, reject) => {
            return api.auth
              .register(data)
              .then((response) => {
                return resolve(response);
              })
              .catch((e) => {
                return reject(e.response);
              });
          });
        },
        forgotPasswordRequest: (email) => {
          return new Promise((resolve, reject) => {
            api.password
              .forgot(email)
              .then((response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        resetPostRequest: (data) => {
          return new Promise((resolve, reject) => {
            api.password
              .reset(data)
              .then(() => {
                resolve();
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        postReviewsRequest: (id, data) => {
          return new Promise((resolve, reject) => {
            api.reviews
              .postReview(id, data)
              .then((result) => {
                resolve(result.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        validateOrderRequest: (_data) => {
          return new Promise((resolve, reject) => {
            api.order
              .validateOrder(_data)
              .then((result) => {
                resolve(result.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        paymentIntentCanceledRequest: (_data) => {
          return new Promise((resolve, reject) => {
            api.order
              .paymentIntentCanceled(_data)
              .then((result) => {
                resolve(result.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        reOrderRequest: (id) => {
          return new Promise((resolve, reject) => {
            api.order
              .reOrder(id)
              .then((result) => {
                resolve(result);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        fetchMenuItem(locationId, menuItemId) {
          return new Promise((resolve, reject) => {
            api.locations
              .menuItem(locationId, menuItemId)
              .then((result) => {
                resolve(result);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        fetchTrackingOrder(params) {
          return new Promise((resolve, reject) => {
            api.order
              .getTrackedOrder(params)
              .then((result) => {
                resolve(result);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        DeleteUserAccount() {
          return new Promise((resolve, reject) => {
            api.auth
              .delete()
              .then((result) => {
                resolve(result);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        getUserOrdersRequest: (pagination) => {
          return new Promise((resolve, reject) => {
            api.order
              .getUserOrders(pagination)
              .then((response) => {
                resolve(response.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        getCurrentOrderRequest: (pagination) => {
          return new Promise((resolve, reject) => {
            api.order
              .getCurrentOrder(pagination)
              .then((response) => {
                resolve(response.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        getCurrentGuestRequest: (idGuest) => {
          return new Promise((resolve, reject) => {
            api.order
              .getGuestCurrentOrder(idGuest)
              .then((response) => {
                resolve(response.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        showOrderRequest: (orderId) => {
          return new Promise((resolve, reject) => {
            api.order
              .show(orderId)
              .then((response) => {
                resolve(response.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        /************************Order*********************/
        postOrderRequest: (data) => {
          return new Promise((resolve, reject) => {
            api.order
              .postOrder(data)
              .then((result) => {
                resolve(result.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        postGuestOrderRequest: (data) => {
          return new Promise((resolve, reject) => {
            api.order
              .postGuestOrder(data)
              .then((result) => {
                resolve(result.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        makeUserPaymentRequest: (data) => {
          return new Promise((resolve, reject) => {
            api.order
              .makeUserPayment(data)
              .then((result) => {
                resolve(result.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        makeGuestPaymentRequest: (data) => {
          return new Promise((resolve, reject) => {
            api.order
              .makeGuestPayment(data)
              .then((result) => {
                resolve(result.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
        postCheckItemsAvailibilityRequest: (data) => {
          return new Promise((resolve, reject) => {
            api.order
              .postCheckItemsAvailibility(data)
              .then((result) => {
                resolve(result.data);
              })
              .catch((e) => {
                reject(e.response);
              });
          });
        },
      },
    });
  },
};
export default Connector;
